import App from './App'

if (process.env.NODE_ENV !== 'production') {
    const Stats = require('stats.js');
    const stats = new Stats();
    document.body.appendChild(stats.domElement);
    const render = () => {
        stats.update();
        window.requestAnimationFrame(render);
    };
    window.requestAnimationFrame(render);
}

const app = new App()
export default app



// WEBPACK FOOTER //
// ./src/app/index.js